var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show && _vm.visible)?_c('div',{class:_vm.classes},[_c('div',{staticClass:"spinner"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }